import styled from '@emotion/styled';
import { Box, Button, TransparentButton } from '~Styles';
import { insideWrapperStyles } from '~ComponentsImproved/Modal';
import { handyBreakpoint } from '~Styles/breakpoints';
import NavigateLeftIcon from '~/Assets/icons/navigate-left.svg';

export const ModalWrapper = styled(Box)`
  position: relative;
  overflow-y: auto;
  box-shadow: ${insideWrapperStyles.boxShadow};
  border-radius: ${insideWrapperStyles.borderRadius};
  background-color: ${insideWrapperStyles.backgroundColor};
`;

export const BackButton = styled(TransparentButton)<{ isHandy?: boolean }>`
  position: absolute;
  top: ${({ isHandy }) => (isHandy ? '8px' : '16px')};
  left: ${({ isHandy }) => (isHandy ? '8px' : '16px')};
  color: var(--colorBlueGray800);
  font-size: 16px;
  text-transform: none;
`;

export const BackButtonIcon = styled.div`
  width: 32px;
  height: 32px;
  mask-image: url(${NavigateLeftIcon});
  mask-size: contain;
  mask-repeat: no-repeat;
  background-color: var(--colorBlueGray800);
  margin-right: 8x;
`;

export const FormatInput = styled.input`
  border-radius: 4px;
  border: 1px solid var(--colorBlueGray1000);
  height: 64px;
  background-color: var(--colorBlueGray1100);
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  font-size: 24px;
  font-weight: 500;
  color: var(--colorWhite);
  padding: 0 20px;
  &:focus {
    border-color: var(--colorBlueGray1000);
    outline: none;
  }
  ${handyBreakpoint} {
    font-size: 20px;
    height: 48px;
    margin: 0px;
    width: 80%;
  }
`;

export const HeaderBox = styled(Box)<{ minHeight?: string }>`
  max-width: 480px;
  text-align: center;
  ${({ minHeight }) => minHeight && `min-height: ${minHeight};`}
`;

export const DevicesBox = styled(Box)`
  border: 1px solid var(--colorBlueGray1000);
  margin: 0 48px 4px 48px;
  overflow-y: scroll;
  flex: 1;
  & > *:not(:last-child) {
    border-bottom: 1px solid var(--colorBlueGray1000);
  }
`;

export const ErrorBox = styled(Box)`
  max-width: 480px;
  text-align: center;
`;

export const GoBackButton = styled(Button)`
  max-width: 160px;
  white-space: nowrap;
`;
